import Link from "next/link";
import DateNameDisplay from "./DateNameDisplay";
import { useContext } from "react";
import { isEmpty } from "lodash";
import { I18nContext } from "components/I18N";
const config = {
  aws_user_files_s3_bucket: process.env.NEXT_PUBLIC_ENV_S3_BUCKET,
  aws_user_files_s3_bucket_region: "ap-southeast-1",
};

const BlogSection = ({ items = [] }) => {

  function removeHtmlTags(htmlString) {
    if(htmlString){
      return htmlString.replace(/<[^>]*>/g, '');
    }
    return
  }
  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 blog-item">
      {items.map((item, i) => (
        <>
          <Link key={i} href={`/blog/${item.url}`}>
            <div className="flex flex-col cursor-pointer" key={i}>
              <div
                className="rounded-[12px] pt-[66.67%] relative bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://${
                    item.image.bucket
                  }.s3.ap-southeast-1.amazonaws.com/public/${encodeURIComponent(
                    item.image.key
                  )}')`,
                }}
              >
                <div className="absolute top-[16px] left-[11px]">
                  <div className="tag-name">{item.blogCategory?.name}</div>
                </div>
              </div>
              <h4
                className="rec-blog-title font-bold mt-4 mb-2"
                dangerouslySetInnerHTML={{
                  __html:
                    langCode === "en" && !isEmpty(item.titleEN)
                      ? removeHtmlTags(item.titleEN)
                      : removeHtmlTags(item.title),
                }}
              />
              <p
                className="desc-blog mb-4"
                dangerouslySetInnerHTML={{
                  __html:
                    langCode === "en" && !isEmpty(item.shortDescriptionEN)
                      ? item.shortDescriptionEN
                      : item.shortDescription,
                }}
              />
              <DateNameDisplay
                authorName={item.authorName}
                reviewedBy={item.reviewedBy}
                createdAt={item.createdAt}
              />
            </div>
          </Link>
        </>
      ))}
    </div>
  );
};

export default BlogSection;
